import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projectImagesLabels: [],
  allProjectImagesLabels: []
};

export const ProjectImagesLabelsSlice = createSlice({
  name: "projectImagesLabels",
  initialState,
  reducers: {
    getAllProjectImagesLabelsAction: (state, action) => {
      
      state.allProjectImagesLabels = action.payload;
    },
    getSingleProjectImagesLabelsAction: (state, action) => {
      
      state.projectImagesLabels = action.payload;
    },
  },
});

export default ProjectImagesLabelsSlice.reducer;

export const { getAllProjectImagesLabelsAction, getSingleProjectImagesLabelsAction } = ProjectImagesLabelsSlice.actions;
